import {
  useMutation,
  useQueryClient,
  UseMutationOptions,
} from "@tanstack/react-query";

import { useServer } from "../../server/ServerContext";
import { PortalAxiosError } from "../../types";
import { programsKeys } from "./utils";

/**
 *
 * @param programIdentifier program identifier
 * @param options useMutation options
 * @returns useMutation result
 */

export const useProgramUnenroll = (
  options?: UseMutationOptions<void, PortalAxiosError, string>
) => {
  const queryClient = useQueryClient();
  const server = useServer();

  return useMutation<void, PortalAxiosError, string>(
    (programIdentifier: string) =>
      server.put(`programs/${programIdentifier}/unenroll`),
    {
      ...options,
      onSuccess: (data, programIdentifier, context) => {
        queryClient.refetchQueries(programsKeys.list);
        queryClient.refetchQueries(programsKeys.getOne(programIdentifier));
        options?.onSuccess?.(data, programIdentifier, context);
      },
    }
  );
};

export default useProgramUnenroll;
